import styled, { css } from 'styled-components';
export const StepsManagerContainer = styled.div `
  height: 100%;
  display: flex;
  flex-direction: column;

  ${({ $enableDragAndDrop }) => $enableDragAndDrop &&
    css `
      overflow: hidden;
    `}
`;
export const ScrollArea = styled.div `
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  overflow: auto;

  padding-block: ${({ theme }) => theme.spacing.xs}px;
  &::-webkit-scrollbar {
    height: 10px;
    width: 8px;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.purple_1}EE;
    transition: background 400ms ease;
    border-radius: 99px;

    cursor: pointer;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: ${({ theme }) => theme.colors.purple_2};
  }
`;
export const StepsManagerContent = styled.div `
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.lg}px;
  align-items: stretch;
  height: 100%;
  a {
    text-decoration: none;
  }
`;
export const StepsManagerColContainer = styled.div `
  display: flex;
  flex-direction: column;

  width: 332px;
  flex-grow: 0;
  flex-shrink: 0;

  border: 1px solid ${({ theme }) => theme.colors.primary};
  background-color: ${({ theme }) => theme.colors.beige_1};

  height: 100%;
  border-radius: ${({ theme }) => theme.border_radius.sm};
  overflow: hidden;
  position: relative;

  ${({ $enableDragAndDrop }) => $enableDragAndDrop &&
    css `
      border: none;
      overflow: visible;
    `}
`;
export const StepsManagerColContent = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm}px;
  height: 100%;
  min-height: 200px;
  overflow-y: auto;
  overflow-x: visible;
  padding-inline: ${({ theme }) => theme.spacing.sm}px;
  padding-block: ${({ theme }) => theme.spacing.sm}px;
  position: relative;
  transition: all 0.2s ease;

  ${({ $isDraggedOver }) => $isDraggedOver &&
    css `
      background-color: ${({ theme }) => theme.colors.purple_5}EE;
      border: 2px dashed ${({ theme }) => theme.colors.purple_2};
    `}

  /* Scrollbar styling for drag and drop */
  &::-webkit-scrollbar {
    width: 2px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.white_2};
    transition: background 400ms ease;
    border-radius: 99px;
    cursor: pointer;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${({ theme }) => theme.colors.purple_2};
  }

  ${({ $enableDragAndDrop }) => $enableDragAndDrop &&
    css `
      border-left: 1px solid ${({ theme }) => theme.colors.primary};
      border-right: 1px solid ${({ theme }) => theme.colors.primary};
    `}
`;
export const StepsManagerColHeader = styled.div `
  padding-inline: ${({ theme }) => theme.spacing.sm}px;
  padding-block: ${({ theme }) => theme.spacing.xs}px;
  background: ${({ theme }) => theme.colors.beige_3};
  box-shadow: ${({ theme }) => theme.appearance.box_shadow};
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey_4};

  ${({ $enableDragAndDrop }) => $enableDragAndDrop &&
    css `
      z-index: 1;
      border-top-left-radius: ${({ theme }) => theme.border_radius.sm};
      border-top-right-radius: ${({ theme }) => theme.border_radius.sm};
      border-left: 1px solid ${({ theme }) => theme.colors.primary};
      border-right: 1px solid ${({ theme }) => theme.colors.primary};
      border-top: 1px solid ${({ theme }) => theme.colors.primary};
      position: sticky;
      top: 0;
    `}
`;
export const StepsManagerColFooter = styled.div `
  border-top: 1px solid ${({ theme }) => theme.colors.grey_4};

  width: 100%;
  padding-inline: ${({ theme }) => theme.spacing.sm}px;
  padding-block: ${({ theme }) => theme.spacing.xs}px;
  background: ${({ theme }) => theme.colors.beige_3};
  box-shadow: ${({ theme }) => theme.appearance.box_shadow};

  ${({ $enableDragAndDrop }) => $enableDragAndDrop &&
    css `
      z-index: 1;
      border-bottom-left-radius: ${({ theme }) => theme.border_radius.sm};
      border-bottom-right-radius: ${({ theme }) => theme.border_radius.sm};
      border-left: 1px solid ${({ theme }) => theme.colors.primary};
      border-right: 1px solid ${({ theme }) => theme.colors.primary};
      border-bottom: 1px solid ${({ theme }) => theme.colors.primary};
      position: sticky;
      bottom: 0;
    `}
`;
export const StepsManagerCardContainer = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.sm}px;
  color: ${({ theme }) => theme.colors.primary};
  background: ${({ theme }) => theme.colors.white_1};
  border: 1px solid ${({ theme }) => theme.colors.primary};
  box-shadow: ${({ theme }) => theme.appearance.box_shadow};
  flex-shrink: 0;
  transition: all 0.2s ease;
  ${({ $hoverable, theme }) => $hoverable
    ? `
  &:hover {
    cursor: grab;
    box-shadow: ${theme.appearance.box_shadow_hover};
    transform: scale(1.02);
  }
  &:active {
    cursor: grabbing;
    transform: scale(1.05);
    opacity: 0.8;
    z-index: 1000;
  }
  `
    : undefined}
  border-radius: 4px;
  padding: ${({ theme }) => theme.spacing.lg}px;
  padding-inline: ${({ theme }) => theme.spacing.sm}px;
  padding-block: ${({ theme }) => theme.spacing.sm}px;

  .ant-badge {
    display: block;
    width: 100%;
  }
`;
export const StepsManagerCardBody = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs}px;
`;
export const ModalContainer = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
`;
export const ModalActions = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.md}px;
`;
export const CardActions = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
export const CardContent = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  gap: ${({ theme }) => theme.spacing.sm}px;
`;
export const CardActions2 = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${({ $gap }) => (typeof $gap === 'number' ? `${$gap}px` : $gap)};
`;
